import React from 'react'

const SearchPage = () => {
	return (
		<div className='container-fluid p-2'>
			<div className='d-flex align-items-center gap-3 border-bottom p-0 mb-2'>
				<div>
					<img src='../../assets/img/products/women/dress/women-10.png' height='50' alt='' />
				</div>
				<div>
					<b className='text-black text-normal'>Women Fashion</b>
				</div>
				<div className='col justify-content-end text-end'>
					<img src='../../assets/img/svg/close.svg' alt='' />
				</div>
			</div>
			<div className='d-flex align-items-center gap-3 border-bottom p-0 mb-2'>
				<div>
					<img src='../../assets/img/products/men/men-1.png' height='50' alt='' />
				</div>
				<div>
					<b className='text-black text-normal'>Men Fashion</b>
				</div>
				<div className='col justify-content-end text-end'>
					<img src='../../assets/img/svg/close.svg' alt='' />
				</div>
			</div>
			<div className='d-flex align-items-center gap-3 border-bottom p-0 mb-2'>
				<div>
					<img src='../../assets/img/products/women/dress/women-product-3.png' height='50' alt='' />
				</div>
				<div>
					<b className='text-black text-normal'>Sarees for Women</b>
				</div>
				<div className='col justify-content-end text-end'>
					<img src='../../assets/img/svg/close.svg' alt='' />
				</div>
			</div>
			<div className='d-flex align-items-center gap-3 border-bottom p-0 mb-2'>
				<div>
					<img src='../../assets/img/products/women/dress/women-13.png' height='50' alt='' />
				</div>
				<div>
					<b className='text-black text-normal'>Western Wear for Women</b>
				</div>
				<div className='col justify-content-end text-end'>
					<img src='../../assets/img/svg/close.svg' alt='' />
				</div>
			</div>
			<div className='d-flex align-items-center gap-3 border-bottom p-0 mb-2'>
				<div>
					<img src='../../assets/img/products/electronics/electronic-2.png' height='50' alt='' />
				</div>
				<div>
					<b className='text-black text-normal'>Samsung s24 Ultra 5g</b>
				</div>
				<div className='col justify-content-end text-end'>
					<img src='../../assets/img/svg/close.svg' alt='' />
				</div>
			</div>
			<div className='d-flex align-items-center gap-3 border-bottom p-0 mb-2'>
				<div>
					<img src='../../assets/img/products/electronics/electronic-4.png' height='50' alt='' />
				</div>
				<div>
					<b className='text-black text-normal'>Oneplus Mobile Phone 5G</b>
				</div>
				<div className='col justify-content-end text-end'>
					<img src='../../assets/img/svg/close.svg' alt='' />
				</div>
			</div>
			<div className='d-flex align-items-center gap-3 border-bottom p-0 mb-2'>
				<div>
					<img src='../../assets/img/products/electronics/electronic-5.png' height='50' alt='' />
				</div>
				<div>
					<b className='text-black text-normal'>Oneplus Mobile Phone 5G</b>
				</div>
				<div className='col justify-content-end text-end'>
					<img src='../../assets/img/svg/close.svg' alt='' />
				</div>
			</div>
			<div className='d-flex align-items-center gap-3 border-bottom p-0 mb-2'>
				<div>
					<img src='../../assets/img/products/electronics/electronic-6.png' height='50' alt='' />
				</div>
				<div>
					<b className='text-black text-normal'>Chargers and Cables for Mobile Phones</b>
				</div>
				<div className='col justify-content-end text-end'>
					<img src='../../assets/img/svg/close.svg' alt='' />
				</div>
			</div>
		</div>
	)
}

export default SearchPage
